"use strict";
/**
 * Strings only with characters, no numbers
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.noNumbersValidator = void 0;
exports.noNumbersValidator = /^([^0-9]*)$/;
